import type { MappingSaveScope } from './element-imports.store';

export type SaveMappingDialogPrefs = {
  scope: MappingSaveScope;
  alsoMapMatching: boolean;
};

const STORAGE_VERSION = 1;

const storageKey = (): string =>
  `nodon.save-mapping-dialog-prefs.v${STORAGE_VERSION}`;

const isMappingSaveScope = (value: unknown): value is MappingSaveScope =>
  value === 'org' || value === 'project';

const isSaveMappingDialogPrefs = (
  value: unknown,
): value is SaveMappingDialogPrefs => {
  if (typeof value !== 'object' || value === null) return false;
  const { scope, alsoMapMatching } = value as Record<string, unknown>;
  return isMappingSaveScope(scope) && typeof alsoMapMatching === 'boolean';
};

/** Last scope + matching-row choice from the save-mapping dialog, if any. */
export const loadSaveMappingDialogPrefs = ():
  SaveMappingDialogPrefs | undefined => {
  if (typeof window === 'undefined') return undefined;
  try {
    const raw = window.localStorage.getItem(storageKey());
    if (!raw) return undefined;
    const parsed: unknown = JSON.parse(raw);
    return isSaveMappingDialogPrefs(parsed) ? parsed : undefined;
  } catch {
    return undefined;
  }
};

/** Persist the user's last save-mapping dialog choices. */
export const saveSaveMappingDialogPrefs = (
  prefs: SaveMappingDialogPrefs,
): void => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(storageKey(), JSON.stringify(prefs));
  } catch {
    // Quota / disabled storage — drop silently.
  }
};
